export const arrow_down_left = () => (
  <path
    d="M17 7L7 17m0 0h10M7 17V7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
